<template lang="pug">
.v-main-banner.main-banner(v-if="data" :key="isTablet" :id="data?.id")
	.main-banner__slide(:style="{backgroundImage: `url('${data.backgroundImage}')`, backgroundColor: data.backgroundColor}")
		.container
			.main-banner__slide-inner
				.main-banner__slide-content
					.main-banner__slide-title(v-if="data.title" :style="{color: data.title.color}" v-html="data.title.text")
					.main-banner__slide-text(v-if="data.text" :style="{color: data.text.color}" v-html="data.text.text")
					a.main-banner__cover-link(v-if="data.link" :href="data.link") {{data.title?.text}}
					.main-banner__slide-actions(v-if="data.action || data.button" :class="[data.bottomActions ?'main-banner__slide-actions--bottom' : '']")
						v-action.main-banner__slide-action.btn(v-if="data.action" :action="data.action")
							template(#icon)
								img.main-banner__slide-action-icon(v-if="data.action.image" :src="data.action.image.src" :alt="data.action.image.alt")
						template(v-if="!isTablet")
							v-action.main-banner__slide-action.btn(v-if="data.button" :action="data.button")
								template(#icon)
									img.main-banner__slide-action-icon(v-if="data.button.image" :src="data.button.image.src" :alt="data.button.image.alt")
				.main-banner__slide-banner(v-if="data.image")
					img.main-banner__slide-banner-img(:src="data.image.src" fetchpriority="high" :alt="data.image.alt")

	.main-banner__buttons(v-if="data.button && isTablet")
		v-action.main-banner__slide-action.btn(v-if="data.button" :action="data.button")
			template(#icon)
				img.main-banner__slide-action-icon(v-if="data.button.image" :src="data.button.image.src" :alt="data.button.image.alt")
</template>

<script>


import sourceMixin from "./mixins/v-mixin-source.vue";
import breakpoints from "../scripts/breakpoints.js";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>
